export const SIDEBAR_COLLAPSED_CLASS_NAME = 'sidebar-collapsed';
